import { isSameDay, DisplayDate, formatUserDate, formatUserTime } from 'owa-datetime';
import { FileInsightLastActivityType } from '../store/schema/FileInsightType';
import { observableToday } from 'owa-observable-datetime';

export function getRelatedFilesTimestamp(
    isFromUserMailbox: boolean,
    sentTime: DisplayDate,
    lastModifiedTime: DisplayDate
): { timestamp: string; lastActivityType: FileInsightLastActivityType } {
    let lastActivityTime;
    let lastActivityType;
    // loc strings
    if (lastModifiedTime && !isFromUserMailbox) {
        lastActivityTime = lastModifiedTime;
        lastActivityType = 'modify';
    } else if (sentTime) {
        lastActivityTime = sentTime;
        lastActivityType = 'send';
    }

    return {
        timestamp: formatTimestamp(lastActivityTime),
        lastActivityType: lastActivityType,
    };
}

export function getRelatedEmailsTimestamp(timeStamp: DisplayDate): string {
    return formatTimestamp(timeStamp);
}

function formatTimestamp(timeStamp: DisplayDate): string {
    return isSameDay(timeStamp, observableToday())
        ? formatUserTime(timeStamp)
        : formatUserDate(timeStamp);
}
